import "@/App.css";
import RehabManagement from "@/pages/RehabManagement";
import { InspectionsPage, ServiceAreasPage, AreaPage, AboutPage, LegalPage } from "@/pages/InspectionsSite";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/site/Layout";
import { SeoManager } from "@/components/site/SeoManager";

import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Packages from "@/pages/Packages";
import FinancingHub from "@/pages/FinancingHub";
import FinancingProduct from "@/pages/FinancingProduct";
import MontgomeryCounty from "@/pages/MontgomeryCounty";
import HowItWorks from "@/pages/HowItWorks";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import SubmitProperty from "@/pages/SubmitProperty";
import RequestFinancing from "@/pages/RequestFinancing";
import ClientLogin from "@/pages/portal/PortalLogin";
import ClientPortal from "@/pages/portal/Portal";
import FieldServices from "@/pages/FieldServices";
import { FieldCategory, FieldServiceDetail, RequestInspection } from "@/pages/FieldCategory";
import Wholesale from "@/pages/Wholesale";
import Buy from "@/pages/Buy";
import Sell from "@/pages/Sell";
import Section8 from "@/pages/Section8";
import RegisterBuyBox from "@/pages/RegisterBuyBox";
import RegisterDeal from "@/pages/RegisterDeal";
import PropertyInspections from "@/pages/PropertyInspections";
import InspectionBook from "@/pages/InspectionBook";
import PropertyPreservation from "@/pages/PropertyPreservation";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AdminForgotPassword, AdminResetPassword } from "@/pages/admin/AdminPassword";

function SiteRoutes() {
  return (
    <Layout>
      <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/financing" element={<FinancingHub />} />
            <Route path="/financing/:slug" element={<FinancingProduct />} />
            <Route path="/counties" element={<Navigate to="/service-areas" replace />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/service-areas/:slug" element={<AreaPage />} />
            <Route path="/property-preservation" element={<PropertyPreservation />} />
            <Route path="/inspections" element={<InspectionsPage />} />
            <Route path="/rehab-project-management" element={<RehabManagement />} />
            <Route path="/privacy" element={<LegalPage title="Privacy Policy" />} />
            <Route path="/terms" element={<LegalPage title="Terms" />} />
            <Route path="/pa-auction-services/northumberland-county" element={<MontgomeryCounty />} />
            <Route path="/ohio-auction-services/montgomery-county" element={<Navigate to="/inspections" replace />} />
            <Route path="/property-inspections" element={<PropertyInspections />} />
            <Route path="/field-services" element={<FieldServices />} />
            <Route path="/field-services/service/:id" element={<FieldServiceDetail />} />
            <Route path="/field-services/:category" element={<FieldCategory />} />
            <Route path="/request-inspection" element={<RequestInspection />} />
            <Route path="/property-inspections/book" element={<InspectionBook />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/submit-property" element={<SubmitProperty />} />
            <Route path="/request-financing" element={<RequestFinancing />} />
            <Route path="/client-login" element={<ClientLogin />} />
            <Route path="/client-portal" element={<ClientPortal />} />
            <Route path="/wholesale" element={<Wholesale />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/register-buy-box" element={<RegisterBuyBox />} />
            <Route path="/register-deal" element={<RegisterDeal />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SeoManager />
        <Routes>
          <Route path="/section8" element={<Section8 />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/*" element={<SiteRoutes />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="light" />
    </div>
  );
}

export default App;
